import { render, staticRenderFns } from "./IconHeart.vue?vue&type=template&id=8103e508&scoped=true&"
import script from "./IconHeart.vue?vue&type=script&lang=ts&"
export * from "./IconHeart.vue?vue&type=script&lang=ts&"
import style0 from "./IconHeart.vue?vue&type=style&index=0&id=8103e508&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8103e508",
  null
  
)

export default component.exports